/**
 * Social sign-in helpers for the Budflow GoTrue endpoint.
 *
 * The round-trip is GoTrue's: we send the browser to /authorize, GoTrue
 * bounces to the provider, the provider returns to GoTrue's own /callback
 * (the URI registered with Google — https://budflow.com/catalyst/auth/callback),
 * and GoTrue finally redirects back to `redirect_to` with the session in the
 * URL hash. `magic-link-handler.tsx` — mounted in `_layout`, so it runs on
 * every page — parses that hash and lands the session.
 *
 * `redirect_to` is validated server-side against GOTRUE_URI_ALLOW_LIST; an
 * unlisted value is silently swapped for GOTRUE_SITE_URL rather than
 * rejected, so keep these same-origin.
 */

export const BUDFLOW_AUTH_BASE = 'https://budflow.com/catalyst/auth';

export type OAuthProvider = 'google' | 'apple';

/**
 * Send the browser off to the provider. Returns the user to the page they
 * started on, so signing in from a product page doesn't lose their place.
 */
export function startOAuthLogin(provider: OAuthProvider): void {
  if (typeof window === 'undefined') return;

  const returnTo = `${window.location.pathname}${window.location.search}`;
  const redirectTo = new URL(returnTo, window.location.origin).toString();

  const url =
    `${BUDFLOW_AUTH_BASE}/authorize` +
    `?provider=${encodeURIComponent(provider)}` +
    `&redirect_to=${encodeURIComponent(redirectTo)}`;

  window.location.assign(url);
}
